import React, { useEffect, useRef, useState } from "react";
import "../style/TopImg.scss";
// import { useInViewport } from "react-in-viewport";

const TopImg = (props) => {
  const { imgurl, imgurlColor } = props;
  const colorRef = useRef(null);
  // const { inViewport } = useInViewport(colorRef);

  // useEffect(() => {
  //   if (colorRef.current) {
  //     // colorRef.current.style.opacity = 0;
  //     // colorRef.current.style.opacity = 1;
  //     setLoaded(true);
  //   }
  // }, [colorRef]);

  // useEffect(() => {
  //   // console.log("inView: ", inViewport);
  // }, [inViewport]);

  return (
    <div className="top-img">
      <img className="bg-img" src={process.env.PUBLIC_URL + "/" + imgurl} />
      <img
        className={`color-img img-added`}
        src={process.env.PUBLIC_URL + "/" + imgurlColor}
        ref={colorRef}
      />
    </div>
  );
};

export default TopImg;

{
  /* <svg
        width="840"
        height="840"
        viewBox="0 0 840 840"
        fill="none"
        className="svg-box"
      >
        <path
          d="M825.553 378.451V387.909L822.114 392.209L819.104 395.648L773.102 410.695L772.242 415.425L767.943 426.603L764.074 826.004H749.456L748.167 427.463L743.867 415.425L596.403 420.154L583.935 721.102H571.897L574.046 607.172L578.776 418.004L470.004 409.406L464.845 423.163L457.966 546.552L443.349 825.144H428.301L430.881 757.646L436.04 651.884L442.059 494.531L444.209 420.154L438.62 403.817L405.085 396.508L386.599 387.05L378 374.152L378.86 362.974L394.337 349.646L414.114 337.608L449.368 329.439L485.052 326H566.738C599.412 326 662.611 329.869 684.537 333.739C711.634 338.52 780.411 351.796 817.815 368.563C821.254 370.105 824.55 375.442 825.553 378.451Z"
          stroke="#499327"
          strokeWidth="8"
          strokeLinejoin="round"
          className="path"
        />
        <defs>
          <rect width="840" height="840" fill="white" />
        </defs>
      </svg> */
}
